import { bl_wms_item_label_link_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class WMSItemLabelLinkContainerModel extends BaseContainerModel {
  bl_wms_item_label_link: bl_wms_item_label_link_RowClass =
    new bl_wms_item_label_link_RowClass();
}
